import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import PartnerDetail from './detail';
@withTranslation()
export default class PartnerDetails extends React.Component {
  render() {
    const { match } = this.props;
    const params = match.params;

    return <PartnerDetail partnerId={params.id} />;
  }
}

PartnerDetails.propTypes = {
  match: PropTypes.object,
};

PartnerDetails.defaultProps = {
  match: {},
};
